import { useState } from "react";
import { useDispatch } from "react-redux";
import BaseConfirmModal from "../../../components/ui/BaseConfirmModal";
import { approveEngineerProfile } from "../../../services/api/admin";
import { showToast } from "../../../store/toast/toastSlice";

const ApproveEngineerModal = ({
  isApproveEngineerModalOpen,
  setIsApproveEngineerModalOpen,
  onStatusChange,
  selectedEngineer,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmApprovalButton = async () => {
    try {
      setIsLoading(true);
      await approveEngineerProfile(selectedEngineer.id);
      onStatusChange?.(selectedEngineer.id, "APPROVED");
      dispatch(showToast({ message: "Engineer approved successfully", type: "success" }));
      setIsApproveEngineerModalOpen(false);
    } catch (error) {
      dispatch(
        showToast({
          message: error?.response?.data?.message || "Failed to approve engineer",
          type: "error",
        }),
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BaseConfirmModal
      open={isApproveEngineerModalOpen}
      onClose={() => setIsApproveEngineerModalOpen(false)}
      onConfirm={handleConfirmApprovalButton}
      isLoading={isLoading}
      title="Confirm Approval"
      description={
        <>
          A confirmation email will be sent to the user on{" "}
          <span className="font-medium">{selectedEngineer?.email}</span>
        </>
      }
      confirmText="Confirm"
    />
  );
};

export default ApproveEngineerModal;
